import React from "react";
import PropTypes from "prop-types";
import { Search } from "lucide-react";
import { NoData } from "../../../../Components/ui";

const TermsEmptyState = ({
  title = "No Clauses Found",
  description = "We couldn't find any terms or clauses matching your search keyword. Try adjusting your query or resetting the search filter.",
  actionText = "Clear Search",
  onAction,
}) => {
  return (
    <NoData
      title={title}
      description={description}
      icon={<Search size={32} />}
      actionText={actionText}
      onAction={onAction}
      minHeight={300}
    />
  );
};

TermsEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
};

export default TermsEmptyState;
